module.exports = __webpack_public_path__ + "img/hr-green-asterisk-17.43dc09be.png";